import React, { useEffect, useState } from 'react';
import Icon from '../components/Icon';
import { onNeedRefresh, reloadToNewVersion } from '../lib/sw';

// A new build of the web app is downloaded and waiting: say so, reload on click.
export default function UpdatePrompt() {
  const [ready, setReady] = useState(false);
  useEffect(() => onNeedRefresh(setReady), []);
  if (!ready) return null;
  return (
    <button className="btn sm" style={{ borderColor: 'var(--c-gold)', color: 'var(--c-gold)' }} onClick={reloadToNewVersion} title="A new version of BattleOps is ready">
      <Icon name="download" size={13} />New version · Reload
    </button>
  );
}
